import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid #888888',
    borderRadius: '4px',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    padding: '0 12px 0 16px',
    background: 'white',
    cursor: 'pointer'
  }
}))

export default useStyles
